function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: 0.769,
  y1: 0.835,
  x2: 0.177,
  y2: 0.205,
  gradientUnits: "objectBoundingBox"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#004683",
  stopOpacity: 0.82
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_5",
  "data-name": "Layer 5",
  transform: "translate(-347.436 -284.639)"
}, React.createElement("g", {
  id: "Group_9",
  "data-name": "Group 9"
}, React.createElement("path", {
  id: "Path_12",
  "data-name": "Path 12",
  d: "M374.994,363.946c0-11.488,14.774-49.189,65.318-54.748",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 9
}), React.createElement("g", {
  id: "Group_8",
  "data-name": "Group 8"
}, React.createElement("path", {
  id: "Path_22",
  "data-name": "Path 22",
  d: "M100,0A100,100,0,1,1,0,100,100,100,0,0,1,100,0Z",
  transform: "translate(347.436 284.639)",
  fill: "url(#linear-gradient)"
}), React.createElement("g", {
  id: "Group_7",
  "data-name": "Group 7"
}, React.createElement("path", {
  id: "Path_13",
  "data-name": "Path 13",
  d: "M435.07,401.326h23.872V386.955H435.07Zm11.936-9.581a2.4,2.4,0,1,1-2.387,2.4A2.392,2.392,0,0,1,447.006,391.745Z",
  fill: "#fff"
}), React.createElement("path", {
  id: "Path_14",
  "data-name": "Path 14",
  d: "M480.06,353.424c-12.573,0-20.184-2.35-24.355-4.322-4.248-2.007-5.85-4.027-5.994-4.217a2.311,2.311,0,0,0-3.8-.183c-.139.156-2.071,2.251-6.742,4.328-4.509,2-12.543,4.394-25.215,4.394a2.39,2.39,0,0,0-2.387,2.395v38.322c0,9.746,6.147,18.239,17.777,24.559,7.9,4.295,16.724,6.577,17.664,6.577.838,0,9.57-2.178,17.664-6.577,11.63-6.32,17.777-14.813,17.777-24.56V355.819A2.39,2.39,0,0,0,480.06,353.424Zm-16.343,50.3a2.392,2.392,0,0,1-2.387,2.395H432.683a2.392,2.392,0,0,1-2.388-2.395V384.56a2.391,2.391,0,0,1,2.388-2.395h2.394V374.9a11.929,11.929,0,0,1,23.858,0,2.388,2.388,0,1,1-4.775,0,7.154,7.154,0,0,0-14.308,0v7.265H461.33a2.391,2.391,0,0,1,2.387,2.395Z",
  fill: "#fff"
})))));

var SvgIt = function SvgIt(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIt, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/it.0bdab9b0.svg";
export { ForwardRef as ReactComponent };